import { iconsMap } from "../public/icons/iconsMap"
import { colors } from "../ui/theme/colors"

export const getArrowIcon = (hexCode: string): any | undefined => {
  const iconKey = colors.getArrowIconNoLinesKey(hexCode)
  if (!iconKey) {
    console.warn(`No icon found for hex code: ${hexCode}`)
    return undefined
  }
  return iconsMap[iconKey]
}
